'use client';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

import { ComponentErrorBoundary } from '@/components';
import { useT } from '@/hooks';

import { SORT_OPTIONS } from '@/constants';

interface FilterPanelProps {
  sortBy: string;
  hideSports: boolean;
  onSortByChange: (val: string) => void;
  onHideSportsChange: (val: boolean) => void;
}

export const FilterPanel = ({
  sortBy,
  hideSports,
  onSortByChange,
  onHideSportsChange,
}: FilterPanelProps) => {
  const { t } = useT();
  const handleSortChange = (e: any) => onSortByChange(e.target.value);
  const handleSportsCheck = (e: React.ChangeEvent<HTMLInputElement>) =>
    onHideSportsChange(e.target.checked);

  const sortMenuItems = Object.values(SORT_OPTIONS).map((option) => (
    <MenuItem key={option} value={option}>
      {t(`filter.${option}`)}
    </MenuItem>
  ));

  return (
    <ComponentErrorBoundary componentName="Filter Panel">
      <Box
        sx={{
          mb: 3,
          p: 2,
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>{t('filter.sortBy')}</InputLabel>
            <Select value={sortBy} label={t('filter.sortBy')} onChange={handleSortChange}>
              {sortMenuItems}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
            <FormControlLabel
              control={<Checkbox checked={hideSports} onChange={handleSportsCheck} size="small" />}
              label={t('filter.hideSports')}
            />
          </Box>
        </Box>
      </Box>
    </ComponentErrorBoundary>
  );
};
